import { __decorate, __metadata } from 'tslib';
import { ɵɵdefineInjectable, Injectable, EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';

let UiCHeaderAppService = class UiCHeaderAppService {
    constructor() {
        this.disableButton = false;
        this.disableButton$ = new Subject();
        this.initObservable();
    }
    // inicio do observable
    initObservable() {
        this.disableButton$.subscribe(res => this.disableButton = res);
    }
    // retorna o observable
    createObservable() {
        return this.disableButton$.asObservable();
    }
    // atualiza o status cpf
    updateStatus(value) {
        this.disableButton$.next(value);
    }
    getStatus() {
        return this.disableButton;
    }
};
UiCHeaderAppService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UiCHeaderAppService_Factory() { return new UiCHeaderAppService(); }, token: UiCHeaderAppService, providedIn: "root" });
UiCHeaderAppService = __decorate([
    Injectable({
        providedIn: 'root'
    }),
    __metadata("design:paramtypes", [])
], UiCHeaderAppService);

let UiCHeaderComponent = class UiCHeaderComponent {
    constructor(service) {
        this.service = service;
        this.goBack = new EventEmitter();
        this.type = 'onboard';
        this.backButton = true;
        this.altText = 'brand image';
        this.disableBack = this.service.getStatus();
    }
    set disableBackBtn(value) {
        this.disableBack = value;
        this.service.updateStatus(value);
    }
    goBackButton() {
        if (!this.disableBack) {
            this.goBack.emit();
        }
    }
};
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCHeaderComponent.prototype, "altText", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCHeaderComponent.prototype, "imagePath", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCHeaderComponent.prototype, "backButton", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCHeaderComponent.prototype, "backgroundImage", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCHeaderComponent.prototype, "type", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCHeaderComponent.prototype, "mode", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCHeaderComponent.prototype, "goBack", void 0);
__decorate([
    Input('disableBackBtn'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], UiCHeaderComponent.prototype, "disableBackBtn", null);
UiCHeaderComponent = __decorate([
    Component({
        selector: 'ui-c-header',
        template: "<ion-header [ngClass]=\"'ion-header ion-header-' + type + ' ion-no-border'\">\n  <ion-toolbar class=\"ion-toolbar\" mode=\"md\">\n    <ion-grid\n      class=\"ion-grid ion-no-padding\"\n      [style.background-image]=\"type === 'logon' ? 'url(' + backgroundImage + ')' : ''\"\n    >\n      <ion-row\n        [ngClass]=\"\n          mode === 'image'\n            ? 'ion-row ion-align-items-center ion-justify-content-center'\n            : 'ion-row ion-align-items-center'\n        \"\n      >\n        <ng-container *ngIf=\"backButton && mode != 'image'\">\n          <ion-fab class=\"ion-fab\">\n            <ion-fab-button class=\"ion-fab-button mt-0\" (click)=\"goBackButton()\">\n              <ion-icon class=\"ion-icon\" name=\"chevron-back-outline\"></ion-icon>\n            </ion-fab-button>\n          </ion-fab>\n        </ng-container>\n\n        <ng-container *ngIf=\"mode != 'image'\">\n            <span [ngClass]=\"!backButton ? 'title mode-text' : 'title'\">\n              <ng-content></ng-content>\n            </span>\n        </ng-container>\n\n        <ng-container *ngIf=\"mode != 'text'\">\n          <ion-col\n            [ngClass]=\"mode === 'image' ? 'ion-col ion-text-center' : 'ion-col ion-text-right ion-padding-end'\"\n            [size]=\"mode === 'image' ? 6 : 4\"\n          >\n            <ion-img [ngClass]=\"mode === 'image' ? 'ion-img img-full' : 'ion-img'\" [src]=\"imagePath\" [alt]=\"altText\">\n            </ion-img>\n          </ion-col>\n        </ng-container>\n      </ion-row>\n    </ion-grid>\n  </ion-toolbar>\n</ion-header>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [UiCHeaderAppService])
], UiCHeaderComponent);

let UiCHeaderModule = class UiCHeaderModule {
};
UiCHeaderModule = __decorate([
    NgModule({
        declarations: [UiCHeaderComponent],
        imports: [
            IonicModule,
            CommonModule
        ],
        providers: [UiCHeaderAppService],
        exports: [UiCHeaderComponent]
    })
], UiCHeaderModule);

export { UiCHeaderAppService, UiCHeaderComponent, UiCHeaderModule };
//# sourceMappingURL=wlp-ui-c-header.js.map
